import React, { createContext, useState, useContext, ReactNode, useCallback, useMemo } from 'react';
import i18n from '../i18n/i18n';

interface LanguageContextValue {
    language: string;
    changeLanguage: (lng: string) => void;
}

const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
    const [language, setLanguage] = useState<string>(i18n.language);

    const changeLanguage = useCallback((lng: string) => {
        i18n.changeLanguage(lng);
        setLanguage(lng);
    }, []);

    const value = useMemo(() => ({ language, changeLanguage }), [language, changeLanguage]);

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = (): LanguageContextValue => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used inside a LanguageProvider');
    }
    return context;
};
